export default __webpack_public_path__ + "static/media/pangong4.a7d25677.jpg";